module.exports = __webpack_public_path__ + "static/media/accesOrangeIcon.c8fc2fee.png";